import api from "./baseApi";
import endpoints from "./endpoints";

// ================= GET ADD-ONS =================

export const getAddOns = async (params = {}) => {
  try {
    const res = await api.get(endpoints.addOn.base, {
      params: {
        page: params.page || 1,
        perPage: params.perPage || 10,
        sortField: params.sortField,
        sortOrder: params.sortOrder,
        ...(params.filters || {}),
      },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch add-ons";
    throw new Error(message);
  }
};

// ================= GET ADD-ON BY ID =================

export const getAddOnById = async (id) => {
  try {
    const res = await api.get(endpoints.addOn.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch add-on";
    throw new Error(message);
  }
};

// ================= CREATE ADD-ON =================

export const createAddOn = async (payload) => {
  try {
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      if (key === "photo") {
        if (value) {
          formData.append("photo", value);
        }
      } else if (typeof value === "object" && value !== null) {
        formData.append(key, JSON.stringify(value));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    const res = await api.post(endpoints.addOn.base, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message ?? "failed to create add-on"
    );
  }
};

// ================= UPDATE ADD-ON =================

export const updateAddOn = async (id, payload) => {
  try {
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      if (key === "photo") {
        if (value) {
          formData.append("photo", value);
        }
      } else if (typeof value === "object" && value !== null) {
        formData.append(key, JSON.stringify(value));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    const res = await api.put(endpoints.addOn.detail(id), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message ?? "failed to update add-on"
    );
  }
};

// ================= BULK ASSIGN LOTS =================

export const bulkAssignAddOnLots = async (
  addOnId,
  payload
) => {
  try {
    const res = await api.post(
      endpoints.addOn.bulkAssignLots(addOnId),
      payload
    );

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message ||
      "failed to update add-on lot assignments";

    throw new Error(message);
  }
};

// ================= DELETE ADD-ON =================

export const deleteAddOn = async (id) => {
  try {
    const res = await api.delete(endpoints.addOn.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete add-on";
    throw new Error(message);
  }
};